import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ParentChatState {
  levels: Array<{ id: string; name: string; code: string }>;
  selectedLevel: string | null;
  subjects: Array<{
    id: string;
    name: string;
    code: string;
    is_required: boolean;
  }>;
  loading: boolean;
  error: string | null;
}

const initialState: ParentChatState = {
  levels: [],
  selectedLevel: null,
  subjects: [],
  loading: true,
  error: null,
};

const parentChatSlice = createSlice({
  name: "parentChat",
  initialState,
  reducers: {
    setLevels: (
      state,
      action: PayloadAction<Array<{ id: string; name: string; code: string }>>
    ) => {
      state.levels = action.payload;
      if (action.payload.length > 0 && !state.selectedLevel) {
        state.selectedLevel = action.payload[0].id;
      }
    },
    setSelectedLevel: (state, action: PayloadAction<string | null>) => {
      state.selectedLevel = action.payload;
    },
    setSubjects: (
      state,
      action: PayloadAction<
        Array<{ id: string; name: string; code: string; is_required: boolean }>
      >
    ) => {
      state.subjects = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setLevels,
  setSelectedLevel,
  setSubjects,
  setLoading,
  setError,
} = parentChatSlice.actions;

export default parentChatSlice.reducer;
